/**
 * Initialize Vue and ES6 for the Thatsup user frontend
 */
import { initVue } from './vue/index.js'
import { initApp } from './es6/index.js'

initVue()
initApp()
